import { render } from "./ButtonPanel.vue?vue&type=template&id=4599c012&scoped=true&ts=true&lang=pug"
import script from "./ButtonPanel.vue?vue&type=script&lang=ts"
export * from "./ButtonPanel.vue?vue&type=script&lang=ts"

import "./ButtonPanel.vue?vue&type=style&index=0&id=4599c012&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4599c012"]])

export default __exports__